import round from 'lodash/round'

export const useImageComp = () => {
  const config = useRuntimeConfig()
  const imageBaseUrl = `${config.public.fileStore}/iiif/2`

  function getScaledSource(id, { width = '', height = '' }) {
    return `${imageBaseUrl}/${id}/full/${width},${height}/0/default.jpg`
  }

  function getImageSource(id, options = {}) {
    const { x = 0, y = 0, width = '', height = '' } = options
    if (x === 0 && y === 0 && width === '' && height === '') {
      return `${imageBaseUrl}/${id}/full/full/0/default.jpg`
    }
    return `${imageBaseUrl}/${id}/${x},${y},${width},${height}/full/0/default.jpg`
  }

  function getPaddedRect(
    {
      x,
      y,
      width,
      height,
    }: { x: number; y: number; width: number; height: number },
    padding = 5
  ) {
    return {
      x: x - padding,
      y: y - padding,
      width: width + 2 * padding,
      height: height + 2 * padding,
    }
  }

  function getContextImageSource(
    id: string,
    {
      x,
      y,
      width,
      height,
    }: { x: number; y: number; width: number; height: number }
  ) {
    return `${imageBaseUrl}/${id}/${x},${y},${width},${height}/full/0/default.jpg`
  }

  function getRoundedRect(
    rect: { x: number; y: number; width: number; height: number },
    n: number = 2
  ) {
    return {
      x: round(rect.x, 2),
      y: round(rect.y, 2),
      width: round(rect.width, 2),
      height: round(rect.height, 2),
    }
  }

  return {
    getPaddedRect,
    getContextImageSource,
    getRoundedRect,
    getScaledSource,
    getImageSource,
  }
}
